import React, { Fragment, useEffect, useState } from 'react';
import axios from 'axios';
import './RelatedContents.scss';

function RelatedContents() {
  const currentUrl = window.location.href;
  const [relatedContentsData, setRelatedContentsData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await axios(
          'https://related-contents-datas.s3.amazonaws.com/intelRelatedContents.json'
        );
        const data = JSON.parse(JSON.stringify(result.data));
        console.log('data', data);
        setRelatedContentsData(data.article3);
      } catch (error) {
        console.log('theres an error', error);
      }
    };
    fetchData();
  }, []);

  return (
    <section className="relatedContents">
      <div className="relatedContents__tiles">
        {relatedContentsData &&
          relatedContentsData.map((data, i) => {
            return (
              <Fragment key={data.content}>
                {currentUrl !== data.url ? (
                  <div
                    className={
                      relatedContentsData[i + 1]
                        ? i === 0
                          ? `relatedContents__tile relatedContents__tile-${data.content} relatedContents__tile-first`
                          : `relatedContents__tile relatedContents__tile-${data.content}`
                        : `relatedContents__tile relatedContents__tile-${data.content} relatedContents__tile-last`
                    }
                    style={{ backgroundImage: `url(${data.background})` }}
                    key={i}
                  >
                    <div className="relatedContents__tile--overlay relatedContents__tile--contents" />
                    <div className="relatedContents__tile--contents relatedContents__tile__content">
                      <p className="relatedContents__tile__title">{data.title}</p>
                      <p className="relatedContents__tile__body">{data.body}</p>
                      <a href={data.url} target="_blank" rel="sponsored">
                        <button className="relatedContents__tile__button">{data.button}</button>
                      </a>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </Fragment>
            );
          })}
      </div>
    </section>
  );
}

export default RelatedContents;
